import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard }            from './_guards/auth.guard';

import { GrantFormComponent }   from './grant-form/grant-form.component';
import { LoginComponent }       from './login/login.component';
import { PasswordResetComponent } from './passwordreset/passwordreset.component';
import { GrantsListComponent }  from './grants-list/grants-list.component';
import { UsersComponent }       from './users/users.component';
import { CreateUserComponent }  from './users/create.user.component';
import { EditUserComponent }    from './users/edit.user.component';
import { MyAccountComponent }   from './my-account/my-account.component';
import { OrgsComponent }        from './orgs/orgs.component';
import { CreateOrgComponent }   from './orgs/create.org.component';
import { EditOrgComponent }     from './orgs/edit.org.component';

const routes: Routes = [
  { path: '',           component: GrantsListComponent, canActivate: [AuthGuard] },
  { path: 'grant-form/:id', component: GrantFormComponent, canActivate: [AuthGuard] },
  { path: 'grant-form', component: GrantFormComponent, canActivate: [AuthGuard] },
  { path: 'login',      component: LoginComponent },
  { path: 'passwordreset', component: PasswordResetComponent },
  { path: 'grantslist', component: GrantsListComponent },
  { path: 'users/add',  component: CreateUserComponent, canActivate: [AuthGuard] },
  { path: 'users/edit/:id',  component: EditUserComponent, canActivate: [AuthGuard] },
  { path: 'users',      component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'my-account', component: MyAccountComponent, canActivate: [AuthGuard] },
  { path: 'organizations/add',  component: CreateOrgComponent, canActivate: [AuthGuard] },
  { path: 'organizations/edit/:id',  component: EditOrgComponent, canActivate: [AuthGuard] },
  { path: 'organizations',      component: OrgsComponent, canActivate: [AuthGuard] },

  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts